import React from 'react';
import tracking from '@finn-no/analytics';
import { EventTrackingConfig } from '@finn-no/analytics/lib/types';
import { DeviceType } from './App';

type Props = {
    className?: string;
    style?: React.CSSProperties;
    deviceType: DeviceType;
    link: string;
    page: 'objectpage' | 'realestate-marketpage';
    partnerName?: string;
};

export const Link = ({ className = 'link', style, deviceType, page, link, partnerName }: Props) => {
    return (
        <a
            onClick={() => track({ page, partnerName })}
            className={className}
            style={style}
            href={link}
            target={deviceType === 'desktop' ? '_blank' : '_top'}>
            {page === 'objectpage'
                ? 'Få flere klikk på din boligannonse'
                : 'Se hvordan du kan få flere klikk på din boligannonse'}
        </a>
    );
};

type TrackingInfo = {
    page: 'objectpage' | 'realestate-marketpage';
    partnerName: string
};

const track = ({ page, partnerName }: TrackingInfo) => {
    const adview: EventTrackingConfig = {
        analyticsName: 'upsale.adboost-blink-clicked.objectpage',
        stringValue: partnerName,
        context: {
            list2: 'cta:adboost-blink-S'
        }
    };
    const realestateMarket: EventTrackingConfig = {
        analyticsName: 'upsale.adboost-blink-clicked.realestate-marketpage',
        stringValue: 'blink-technology',
        context: {
            list2: 'cta:adboost-blink-L'
        }
    };

    page === 'objectpage' ? tracking.trackEventLater(adview) : tracking.trackEventLater(realestateMarket);
};
